import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentfulService } from '../_services/contentful.service';
import { FormsManagementModule } from '../forms-management/forms-management.module';
import { LayoutMangmentModule } from '../layout-mangment/layout-mangment.module';

import { LandingPageV1Component } from './landing-page-v1/landing-page-v1.component';
import { LandingPageV2Component } from './landing-page-v2/landing-page-v2.component';
import { ThankYouPagesModule } from '../thank-you-pages/thank-you-pages.module';

@NgModule({
  declarations: [
    LandingPageV1Component,
    LandingPageV2Component
  ],
  imports: [
    CommonModule,
    FormsManagementModule,
    LayoutMangmentModule,
    ThankYouPagesModule
  ],
  exports: [
    LandingPageV1Component
  ],
  providers: [ContentfulService]
})
export class LandingPagesModule { }
